import URLS from "@/constants/api";
import { get_2 } from "./api";

export const downloadEnquiryCsvAPI = async () => {
  const response = await get_2(URLS.DOWNLOAD_ENQUIRY);
  return response;
};
